import React from "react";
import styles from "./footer.module.css";
import logo from "../../assets/Header/TCS_C4L_LOGO.svg";
import appStoreBadge from "../../assets/Header/appStore.svg";
import playstoreBadge from "../../assets/Header/PlayStore.svg";
import screenshot_collection from "../../assets/WhatsNewSection/Connect_with_Each_Other_Image.png";
import { URL_ROUTES } from "../../routes/UrlList";
import { Box } from "@mui/material";

const Footer = () => {
  return (
    <footer className={styles.footerContainer}>
      <div className={styles.relativeFooterContainer}>
        <div className={styles.gradientSection}>
          <div className={styles.contentGrid}>
            <div style={{ padding: "2rem" }}>
              <h2 className={styles.heading}>
                Connect with each other for the same purpose
              </h2>
              <p className={styles.description}>
                Join hundreds of other TCS associates on the Circle4Life app and
                share stories, blogs, participate in events and track your
                carbon footprint
              </p>
              <div className={styles.storeButtonContainer}>
                {/* <img
                  src={appStoreBadge}
                  alt="Download on App Store"
                  className={styles.storeButton}
                />
                <img
                  src={playstoreBadge}
                  alt="Get it on Google Play"
                  className={styles.storeButton}
                /> */}
                <Box component="a" href="https://apps.apple.com/in/app/tcs-circle4life/id1593154523" target="_blank" rel="noopener noreferrer">
                  <Box
                    component="img"
                    src={appStoreBadge}
                    alt="app store link"
                    sx={{
                      height: 40,
                      width: "auto",
                    }}
                  />
                </Box>
                <Box component="a" href="https://play.google.com/store/apps/details?id=com.tcs.circle4life" target="_blank" rel="noopener noreferrer">

                  <Box
                    component="img"
                    src={playstoreBadge}
                    alt="playstore link"
                    sx={{
                      height: 40,
                      width: "auto",
                    }}
                  />
                </Box>
              </div>
            </div>
            <div>
              <img
                className={styles.footerImage}
                src={screenshot_collection}
                alt="collection of app screenshots"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bottomSection}>
        <div className={styles.container}>
          <div className={styles.gridContainer}>
            <div>
              <img src={logo} alt="TCS Circle4Life" className={styles.logo} />
            </div>

            <div>
              <h3 className={styles.subHeading}>Contact Us</h3>
              <p className={styles.description}>
                We're happy to answer your queries. Please drop us an email at
                <a
                  href="mailto:circle4life.support@tcs.com"
                  className={styles.link}
                  style={{ marginLeft: "5px" }}
                >
                  circle4life.support@tcs.com
                </a>
              </p>
            </div>

            <div>
              <h3 className={styles.subHeading}>Data Privacy</h3>
              <div className={styles.linkStack}>
                <a href={URL_ROUTES.PRIVACY} className={styles.link}>
                  Privacy Policy
                </a>
                <a href={URL_ROUTES.TERMS} className={styles.link}>
                  Terms and Conditions
                </a>
              </div>
            </div>
          </div>

          <p className={styles.copyright}>
            © Copyright {new Date().getFullYear()}, Tata Consultancy Services Limited. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
